import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'orderByDate'
})
export class OrderByDatePipe implements PipeTransform {
	transform(value: any, type: string): any {
		const newVal = value.sort((a: any, b: any) => {
			const date1 = new Date(a[type]).getTime();
			const date2 = new Date(b[type]).getTime();

			if (date1 > date2) {
				return 1;
			} else if (date1 < date2) {
				return -1;
			}
			return 0;
		});

		return newVal;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/pipes/order-by-date/order-by-date.ts